/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Signin_TimeoutInputs */



/**
* | output |
* | --- |
* | "Sign-in timed out. Please try again." |
*
* @param {Login_Error_Signin_TimeoutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_signin_timeout = /** @type {((inputs?: Login_Error_Signin_TimeoutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Signin_TimeoutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Temps de connexion écoulé. Veuillez réessayer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accesso scaduto. Riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время ожидания входа истекло. Пожалуйста, попробуйте еще раз.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se agotó el tiempo de inicio de sesión. Inténtalo de nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("登录超时，请重试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サインインがタイムアウトしました。もう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉग इन करने में समय समाप्त हो गया। कृपया पुनः प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O tempo limite de login expirou. Tente novamente.")
	return /** @type {LocalizedString} */ ("Sign-in timed out. Please try again.")
});